import type { Action } from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

import { ExperimentCohort } from './useReverseTrialLozengeExperiment';

interface ReverseTrialLozengeStore {
	canRenderTreatment: boolean;
	cohort: ExperimentCohort;
	loading: boolean;
	error: string | null;
}
const initialState: ReverseTrialLozengeStore = {
	canRenderTreatment: false,
	cohort: ExperimentCohort.NOT_ENROLLED,
	loading: true,
	error: null,
};
const actions = {
	setCanRenderTreatment:
		(value: boolean): Action<ReverseTrialLozengeStore> =>
		({ setState }) => {
			setState({ canRenderTreatment: value });
		},
	setCohort:
		(cohort: ExperimentCohort): Action<ReverseTrialLozengeStore> =>
		({ setState }) => {
			setState({ cohort });
		},
	setLoading:
		(loading: boolean): Action<ReverseTrialLozengeStore> =>
		({ setState }) => {
			setState({ loading });
		},
	setError:
		(error: string | null): Action<ReverseTrialLozengeStore> =>
		({ setState }) => {
			setState({ error });
		},
};
const store = createStore({
	initialState,
	actions,
	name: 'ReverseTrialLozengeExperimentStore',
});
export const useReverseTrialLozengeState = createStateHook(store);
export const useReverseTrialLozengeActions = createActionsHook(store);
